import { apiWrapper } from "@/services/api";

export const putMamoruOnetimepass = async (frame_id, route, item_name) => {
  try {
    await apiWrapper(
      "PUT",
      `frames/${frame_id}/mamoru_onetimepass?code=${route.query.onetime}&product_name="odakyu"&item_name=${item_name}`
    );
  } catch (err) {
    console.log('ERROR"" postputMamoruOnetimepassFrame()');
    throw err;
  }
};
